const mockData = {
  status: 'OK',
  results: [{ placeholder: '#telesales', response: '' }, {
    placeholder: '#cart',
    response: {
      result: 'OK',
      content: `
        <span id="cart" class="dc-header-item__badge dc-header-item__badge--circle" style="background-color: #999;">
        0</span>`,
      replace: 1
    }
  }, {
    placeholder: '#cart-ie-9',
    response: { result: 'OK', content: '<span class="qty empty">0</span>' }
  }, {
    placeholder: '[data-anonid=\'locationinput\'] > [data-anonid=\'textfield\'] > input',
    response: { result: 'OK', content: '', action: [] }
  }],
  state: {
    search: '',
    oosEmailActive: true,
    userDetails: { email: null, isGuest: null, isHomepageModuleEnabled: true }
  },
  session: '103ec30d37a6d45ab7d05c6b2b554f39',
  digitalData: {
    cart: {
      baseAmount: 0,
      shippingAmount: 0,
      shippingAmountByBoxType: {
        smallBoxDeliveryAmount: 0,
        bigBoxDeliveryAmount: 0,
        sbreDeliveryAmount: 0,
        tradeplaceDeliveryAmount: 0
      },
      discountTotalAmount: 0,
      orderLevelPromoTotal: 0,
      taxAmount: 0,
      totalAmount: 0,
      orderLevelPromoCode: null,
      orderLevelPromoName: null,
      financingAvailable: false
    },
    user: [{
      userIP: '78.102.173.132',
      hashedEmail: null,
      accountType: null,
      loginState: null,
      settings: { email: false, sms: false, phone: false, priceDropToggle: false, sflAvailabilityToggle: false },
      productsSavedForLater: [],
      numberOfOrdersPlaced: 0,
      orders: [],
      valueOfAllOrders: 0
    }]
  }
};

export default mockData;
